import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-254d2e2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "property_details_content !tw-h-full" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 2,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full tw-h-[calc(100dvh-221px)]"
}

import { computed, ref, onBeforeMount, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import PropertyMapTab from "@/modules/properties/components/Tabs/PropertyMapTab.vue";
import PropertyDataTab from "@/modules/properties/components/Tabs/PropertyDataTab.vue";
import PropertyProjectLogTab from "@/modules/properties/components/Tabs/PropertyProjectLogTab.vue";
import PropertyMemberTab from "@/modules/properties/components/Tabs/PropertyMemberTab.vue";
import PropertyComparablesTab from "@/modules/properties/components/Tabs/PropetyComparablesTab.vue";
import PropertyDocumentTab from "@/modules/properties/components/Tabs/PropertyDocumentTab.vue";
import PropertyLegalTab from "@/modules/properties/components/Tabs/PropertyLegalTab.vue";
import PropertyMarketHistoryTab from "@/modules/properties/components/Tabs/PropertyMarketHistoryTab.vue";
// import SamplePropbarQueryBuilder from "@/modules/properties/components/SamplePropbarQueryBuilder.vue";
import { PROPERTY_STORE } from "@/store/modules/property";
import connectionsService from "@/core/services/connections.service";
import { USER_STORE } from "@/store/modules/user";
import { CONNECTIONS } from "@/store/modules/connections";
import Loader from "@/core/components/common/Loader.vue";
import CollapsiblePropertyPriceHistory from "@/modules/properties/components/Collapsibles/CollapsiblePropertyPriceHistory.vue";
import { JOB_DETAILS_ROUTE } from "@/modules/jobs/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyDetailsPage',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const selectedTab = ref();
const loading = ref(true);

const propertyTabList = [
  { name: "property-map", icon: "property-map-icon", label: "Property Map" },
  {
    name: "property-data",
    icon: "property-data-icon",
    label: "Property Data",
  },
  {
    name: "comparables",
    icon: "comparable-icon",
    label: "Comparables",
  },
  {
    name: "market-history",
    icon: "market-history-icon",
    label: "Market History",
  },
  {
    name: "legal",
    icon: "legal-icon",
    label: "Legal",
  },
  {
    name: "projects",
    icon: "projects-filled-icon",
    label: "Projects",
  },
  {
    name: "documents",
    icon: "my-document",
    label: "Documents",
  },
  {
    name: "members",
    icon: "members-icon",
    label: "Members",
  },
];
const isSiteVisitPropertyDetail = computed(
  () => store.getters[`${PROPERTY_STORE}/getIsSiteVisitPropertyDetail`]
);
const filteredTabList = isSiteVisitPropertyDetail.value
  ? propertyTabList.slice(0, 2)
  : propertyTabList;

const propertyId = computed(() => route?.params?.propertyId);
const siteVisitProjectRefId = computed(
  () => store.getters[`${PROPERTY_STORE}/getSiteVisitProjectRefId`]
);
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const currentPropertyConnectionRole = computed(
  () => store.getters[`${CONNECTIONS}/getPropertyConnectionRole`]
);

const init = async () => {
  loading.value = true;
  try {
    await store.dispatch(
      `${PROPERTY_STORE}/fetchPropertyDetails`,
      propertyId.value
    );
  } catch (error) {
    console.log(error, "error in fetching property details");
  } finally {
    loading.value = false;
  }
};

const onRouteToProjectLogs = () => {
  selectedTab.value = "projects";
};

const setPropertyConnectionRole = async () => {
  try {
    const response = await store.dispatch(
      `${CONNECTIONS}/getPropertyConnectionRole`,
      {
        userId: user.value.id,
        propertyId: propertyId.value,
      }
    );
  } catch (error) {
    console.log();
  }
};
onBeforeMount(async () => {
  await init();
  await setPropertyConnectionRole();
});

const backToPropertyPage = () => {
  if (isSiteVisitPropertyDetail.value) {
    router.push({
      name: JOB_DETAILS_ROUTE,
      params: { refId: siteVisitProjectRefId.value },
    });
  } else {
    router.push("/properties");
  }
};
onBeforeUnmount(() => {
  if (isSiteVisitPropertyDetail.value) {
    store.commit(`${PROPERTY_STORE}/setIsSiteVisitPropertyDetail`, false);
  }
});
// onBeforeUnmount(() => {
//   store.dispatch(`${PROPERTY_STORE}/setPropertyDetails`, {});
// });

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tabs, {
      class: "tab-list tw-mb-4",
      modelValue: selectedTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTab).value = $event)),
      "align-tabs": "center",
      stacked: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTabList), (tabItem) => {
          return (_openBlock(), _createBlock(_component_v_tab, {
            key: tabItem.name,
            value: tabItem.name
          }, {
            default: _withCtx(() => [
              (tabItem.icon)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    height: "18px",
                    src: 
            require('@/assets/icons/propety-data-tab/' + tabItem.icon + '.svg')
          ,
                    alt: "ghg"
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(tabItem.label), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (selectedTab.value !== 'projects')
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          class: "back__btn tw-mb-4",
          variant: "plain",
          "prepend-icon": "mdi-chevron-left",
          onClick: backToPropertyPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("Back")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createBlock(_component_v_window, {
          key: 1,
          modelValue: selectedTab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTab).value = $event)),
          class: "tw-overflow-y-auto md:!tw-pb-16 md:!tw-box-border"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTabList), (tabValue) => {
              return (_openBlock(), _createBlock(_component_v_window_item, {
                class: "no-scrollbar md:tw-box-border",
                key: tabValue.name,
                value: tabValue.name
              }, {
                default: _withCtx(() => [
                  (tabValue.name === 'property-map')
                    ? (_openBlock(), _createBlock(PropertyMapTab, {
                        key: 0,
                        onRouteToProjectLogs: onRouteToProjectLogs
                      }))
                    : _createCommentVNode("", true),
                  (tabValue.name === 'comparables')
                    ? (_openBlock(), _createBlock(PropertyComparablesTab, { key: 1 }))
                    : _createCommentVNode("", true),
                  (tabValue.name === 'property-data')
                    ? (_openBlock(), _createBlock(PropertyDataTab, {
                        key: 2,
                        onRouteToProjectLogs: onRouteToProjectLogs
                      }))
                    : _createCommentVNode("", true),
                  (tabValue.name === 'projects')
                    ? (_openBlock(), _createBlock(PropertyProjectLogTab, { key: 3 }))
                    : _createCommentVNode("", true),
                  (tabValue.name === 'members')
                    ? (_openBlock(), _createBlock(PropertyMemberTab, { key: 4 }))
                    : _createCommentVNode("", true),
                  (tabValue.name === 'documents')
                    ? (_openBlock(), _createBlock(PropertyDocumentTab, { key: 5 }))
                    : _createCommentVNode("", true),
                  (tabValue.name === 'legal')
                    ? (_openBlock(), _createBlock(PropertyLegalTab, { key: 6 }))
                    : _createCommentVNode("", true),
                  (tabValue.name === 'market-history')
                    ? (_openBlock(), _createBlock(CollapsiblePropertyPriceHistory, { key: 7 }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(Loader, { show: true })
        ]))
  ]))
}
}

})